import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import _ from 'lodash';

/*Dialog*/
import EmailSpecOverlayDialog from '../../dialogs/emailSpecOverlayDialog';
import EmailSpecOverlayDialogSuccess from '../../dialogs/emailSpecOverlayDialogSuccess';
import ToolTipOverlayDialog from '../../dialogs/toolTipOverlayDialog';

import { routes } from '../../../redux/api/routes';
let { productGEUrl } = routes;

class PreLoginSearchResult extends Component {
    constructor(props){
        super(props);
        this.state = {
            showEmailSpecOverlayDialog: false,
			showToolTipOverlayDialog: false,
            specURL: ''
        }
    }

	componentDidMount() {
		window.scrollTo(0, 0);
	}

    handleClickEmailSpec(specURL, event) {
        event.preventDefault();
        this.setState({
            specURL: specURL,
            showEmailSpecOverlayDialog: true
        });
    }

	handleClickOnImage(imagePath,event){
        window.location.assign(imagePath);
    }

    formatNumber2Decimal(number) {
        if(number) {
            return "$"+parseFloat(number).toFixed(2);
        }else{
            return "";
        }
    }

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    render() {
        var self = this;
        let { productResultAvailability, productNumberKeywordResult } = self.props.state.product;
		var resultCount = '';
		if(productResultAvailability) {
			resultCount = productResultAvailability.length;
			productResultAvailability.map((item, index) => {
				if(item.replacementList) {
					resultCount += item.replacementList.length;
				}
				return null;
			})
		}
		const toolTipContent = `The ETA is when the product will be available to ship from the GE Appliances ADC for an order placed today.<br/><br/>
						<b>6+ mos:</b> Model is currently in production, but demand exceeds all planned supply. “6+ mos.” indicates that we cannot provide an exact ETA date. The system estimate for availability under these conditions is greater than 6 months from today.<br/><br/>
						<b>FP:</b> Model is past the final production date and there is no more supply being produced. “FP” indicates that the model cannot be supplied from the serving warehouse and cannot be ordered.`;
        return (
            <div className="productResultsTableForm withNoBeforeUnloadBehavior" name="productResultsTableForm" id="productResultsTableForm">
               	<div className="captionAboveTable productResultsTableHeader">
                  	<div className="inner">
                     	<div className="resultCount">
                        	<span className="resultCount">{resultCount} Products</span> match your selections.
                     	</div>
                  	</div>
               	</div>
				{/* This template file is for both contract and retail. */}
				{/* See below for contract table. */}
				{/* vvvvvv */}
               	<table className="dataTable productResultsTable retail photosShown priceDetailsHidden">
                  	<thead>
                     	<tr>
	                        <th className="photo" style={{display: 'table-cell'}}>&nbsp;</th>
	                        <th className="productInfo">&nbsp;</th>
	                        <th className="priceColumn msrp" style={{width: '50%'}}>MSRP</th>
                     	</tr>
                  	</thead>
                  	{/* one [tbody] element for each SKU. */}
                  	{/* in situations where you have one SKU replaced by another SKU, both go in the same [tbody]. */}
                  	{/*!productResultAvailability
                      	?<tbody>
                            <tr>
                            	<td className="txt-ctr" colSpan={3}><div className="loader">&nbsp;</div></td>
                            </tr>
                        </tbody>
                  		:null
					*/}
                  	{productResultAvailability && productResultAvailability.length === 0
                      	?<tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td>No results found.</td>
                            </tr>
                        </tbody>
                      :null
				  	}
                  	{productResultAvailability && productResultAvailability.length > 0 && productResultAvailability.map((item, index) => {
						let lifeCyclePhaseValueMultipleValues = productResultAvailability.filter(itm => itm.sku === item.sku);
						let lifeCyclePhase = lifeCyclePhaseValueMultipleValues && lifeCyclePhaseValueMultipleValues.length > 0 ? lifeCyclePhaseValueMultipleValues[0].lifeCyclePhase : null;
						let data = {
							availableQty: item.availableQty,
							intransitQty: item.intransitQty,
							etaDate: item.etaDate,
						};
						if(self.props.checkIfFP(item)) {
							data.intransitQty = null;
							data.etaDate = 'FP';
						} else {
							data = self.props.validateFDD(item);
						}
                      	return <tbody key={index}>
                          	<tr>
                             	<td className="photo" style={{display: 'table-cell'}}>
	                             	<Link to={"/prelogin/product-specs/"+self.props.typeOfSearch+"/"+item.sku} >
									 <img src={item.imagePath} width={96} height={100} alt={item.sku} title={item.sku}/>
                                 	</Link>
                             	</td>
                             	<td className="productInfo">
	                                <div className="skuDiv">
                                   		<Link to={"/prelogin/product-specs/"+self.props.typeOfSearch+"/"+item.sku}>{item.sku}</Link>
	                                </div>
	                                <div className="productNameDiv">
	                                   	{item.description}
	                                </div>
	                                {item.quickSpecPdfName && item.quickSpecPdfName !== ""
	                                    ?<div className="quickSpecLinkDiv">
	                                        <a href={item.quickSpecPdfPath} className="withIcon withQuickSpecIcon bold uppercase" target="_blank">Quick Spec</a>
	                                    </div>
	                                    :null
	                                }
	                                <div className="emailSpecLinkDiv">
	                                	<a className="withIcon withEmailSpecIcon bold uppercase" onClick={this.handleClickEmailSpec.bind(this, "/prelogin/product-specs/"+ self.props.typeOfSearch+"/"+item.sku)} href="">Email Spec</a>
	                                </div>
                             	</td>
                             	<td className="priceColumn msrp">
                                	{this.formatNumber2Decimal(item.msrp)}
                                	<div className="productStatusTablePositioningContainer">
                                   		<table className="productStatusTable">
                                      		<thead>
	                                         	<tr>
		                                            <th>Avail.</th>
		                                            <th>Next Avail</th>
		                                            <th>ETA <a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ToolTipOverlayDialog", true)}>
														<img src="../../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
	                                         	</tr>
                                      		</thead>
                                      		<tbody>
	                                         	{/* NOTE: usually the <tbody> section contains one row. We're just depicting two scenarios here: one where there's an ETA, and the other where it's a closeout. */}
	                                         	{lifeCyclePhase !== "Near End of Life" ? (<tr>
                                                    <td>{data.availableQty}</td>
                                                    <td>{data.intransitQty}</td>
	                                            	<td>{self.props.formatETADate(data.etaDate)}</td>
	                                         	</tr>):(<tr><td></td><td>NLA</td><td></td></tr>)}
	                                      	</tbody>
	                                   	</table>
                                	</div>
                             	</td>
                          	</tr>

							{item.replacementList && item.replacementList.map((itm, ind) => {
                                let data = {
									availableQty: itm.availableQty,
									intransitQty: itm.intransitQty,
									etaDate: itm.etaDate,
								};
								if(self.props.checkIfFP(itm)) {
									data.intransitQty = null;
									data.etaDate = 'FP';
								} else {
									data = self.props.validateFDD(itm);
								}
								return [
									<tr className={"replacedBy "+self.props.typeOfSearch}>
										<td></td>
										<td className="dynamicColumnSpan" colSpan={6}>
											<span className="replacedByText">Replaced By:</span>
										</td>
									</tr>,
									<tr>
		                             	<td className="photo" style={{display: 'table-cell'}}>
										 <Link to="" onClick={this.handleClickOnImage.bind(this,itm.imagePath)}>
		                                     	<img src={itm.imagePath} width={96} height={100} alt="PUT_ALT_TEXT_HERE" title="PUT_ALT_TEXT_HERE" />
		                                 	</Link>
		                             	</td>
		                             	<td className="productInfo">
			                                <div className="skuDiv">
		                                   		<Link to={"/prelogin/product-specs/"+self.props.typeOfSearch+"/"+itm.sku}>{itm.sku}</Link>
			                                </div>
			                                <div className="productNameDiv">
			                                   	{itm.description}
			                                </div>
			                                {itm.quickSpecPdfName !== ""
			                                    ?<div className="quickSpecLinkDiv">
			                                       <a href={itm.quickSpecPdfPath} className="withIcon withQuickSpecIcon bold uppercase" target="_blank">Quick Spec</a>
			                                    </div>
			                                    :null
			                                }
			                                <div className="emailSpecLinkDiv">
			                                	<a className="withIcon withEmailSpecIcon bold uppercase" onClick={this.handleClickEmailSpec.bind(this, "/prelogin/product-specs/"+ self.props.typeOfSearch+"/"+itm.sku)} href="">Email Spec</a>
			                                </div>
		                             	</td>
		                             	<td className="priceColumn msrp">
		                                	{this.formatNumber2Decimal(itm.msrp)}
		                                	<div className="productStatusTablePositioningContainer">
		                                   		<table className="productStatusTable">
		                                      		<thead>
			                                         	<tr>
				                                            <th>Avail.</th>
				                                            <th>Next Avail</th>
				                                            <th>ETA</th>
			                                         	</tr>
		                                      		</thead>
		                                      		<tbody>
			                                         	{/* NOTE: usually the <tbody> section contains one row. We're just depicting two scenarios here: one where there's an ETA, and the other where it's a closeout. */}
			                                         	<tr>
			                                            	<td>{data.availableQty}</td>
			                                            	<td>{data.intransitQty}</td>
			                                            	<td>{self.props.formatETADate(data.etaDate)}</td>
			                                         	</tr>
			                                      	</tbody>
			                                   	</table>
		                                	</div>
		                             	</td>
		                          	</tr>
								]
							})}
						</tbody>
                  	})}
               	</table>
               	{this.state.showEmailSpecOverlayDialog?<EmailSpecOverlayDialog specURL={this.state.specURL} dispatch={this.props.dispatch} handleDialog={this.handleDialog.bind(this)} showDialog={true}/>:null}
               	{(this.props.state && this.props.state.brochure.emailSendSuccessDialog === true)?<EmailSpecOverlayDialogSuccess dispatch={this.props.dispatch} showDialog={true}/>:null}
				{this.state.showToolTipOverlayDialog?<ToolTipOverlayDialog title="ETA" content={toolTipContent} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {state};
};

PreLoginSearchResult = connect(mapStateToProps)(PreLoginSearchResult);
export default PreLoginSearchResult;


// WEBPACK FOOTER //
// ./src/App/components/PreLogin/SearchResult/productSearchResult.js